import { defineMessages } from '@jutro/locale';

export default defineMessages({

    paymentsHeader: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.Payment',
        defaultMessage: 'Payment'
    },
    amountPaid: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.AMOUNT PAID',
        defaultMessage: 'AMOUNT PAID'
    },
    checkMadeTo: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.CHECK MADE OUT TO',
        defaultMessage: 'CHECK MADE OUT TO'
    },
    coverageType: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.COVERAGE TYPE',
        defaultMessage: 'COVERAGE TYPE'
    },
    date: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.DATE',
        defaultMessage: 'DATE'
    },
    total: {
        id: 'ml.gateway.views.AccountClaims.MLClaimPayments.Total',
        defaultMessage: 'Total'
    }
});
